<template>
  <div v-loading="Loading" class="detail-editor">
    <div class="detail-editor__intro">
      这里维护商品在后台与前台展示所需的核心资料，包括分类、组织、标签与内容说明。优先保证标题、Logo 与简介清晰可信。
    </div>
    <el-form ref="form" :rules="rules" :model="appDetail" label-width="80px">
      <div class="detail-editor__section">
        <div class="detail-editor__section-title">基础资料</div>
        <el-form-item prop="name" label="应用名称">
          <el-input v-model="appDetail.name" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="应用分类">
          <el-select
            v-model="categoryID"
            style="width: 360px"
            placeholder="选择应用分类"
            clearable
          >
            <el-option
              v-for="(item, index) in classes"
              :key="index"
              :label="item.appClassificationName"
              :value="item.appClassificationID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="recommended" label="推荐置顶">
          <el-switch
            v-model="appDetail.recommended"
            :active-value="true"
            :inactive-value="false"
            active-color="#13ce66"
            inactive-color="#e3e3e3"
          ></el-switch>
        </el-form-item>
        <el-form-item label="所属组织">
          <el-select
            v-model="appDetail.organizationID"
            placeholder="请选择所属组织"
            style="width: 360px"
            clearable
          >
            <el-option
              v-for="(item, index) in allRoleList"
              :key="index"
              :label="item.name"
              :value="item.orgID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="tags" label="标签">
          <el-select
            v-model="selectedTags"
            multiple
            filterable
            allow-create
            default-first-option
            style="width: 360px"
            placeholder="请输入或选择商品标签"
          >
            <el-option
              v-for="item in existTags"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="8" class="appsFrom">
            <el-form-item
              label="应用Logo"
              ref="uploadpic"
              class="el-form-item-cen"
              prop="logo"
            >
              <el-upload
                class="avatar-uploader"
                :action="uploadConfig.api"
                :with-credentials="true"
                :headers="uploadConfig.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleAvatarError"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="appDetail.logo" :src="appDetail.logo" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <i
                  v-if="appDetail.logo"
                  class="el-icon-delete"
                  @click.stop="() => handleRemove()"
                ></i>
              </el-upload>
              <span class="detail-editor__hint">
                建议上传 100*100 比例的 Logo
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="introduction" label="商品简介">
          <el-input
            type="textarea"
            v-model="appDetail.introduction"
            :rows="3"
            style="width: 360px"
          ></el-input>
        </el-form-item>
      </div>

      <div class="detail-editor__section">
        <div class="detail-editor__section-title">展示内容</div>
        <el-form-item prop="description" label="商品介绍">
          <MdEditor v-if="appDetail.initSuccess" :content.sync="appDetail.description"></MdEditor>
        </el-form-item>
        <el-form-item prop="installDoc" label="安装使用">
          <MdEditor v-if="appDetail.initSuccess" :content.sync="appDetail.installDoc"></MdEditor>
        </el-form-item>
        <el-form-item prop="screenshots" label="产品截图">
          <MdEditor v-if="appDetail.initSuccess" :content.sync="appDetail.screenshots"></MdEditor>
        </el-form-item>
      </div>
    </el-form>
    <div class="detail-editor__footer">
      <el-button
        class="save_btn"
        type="primary"
        @click="onSubmit"
        :loading="commitLoading"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { getStoreAvailableTags } from '@/api/appStore';
import { getToken } from '@/utils/auth';
import axios from 'axios';
import { errorHandle } from '../../../../utils/error';
import { getOrgStructureApi } from '@/api/enterpriseManage';
export default {
  name: 'BasicInfo',
  components: {},
  props: {
    appDetail: {
      type: Object
    },
    marketID: {
      type: String
    },
    Loading: Boolean,
    appType: String
  },
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    const isChinese = (temp) => {
      return /^[\u4e00-\u9fa5]+$/i.test(temp);
    };
    const tagValidate = (rule, value, callback) => {
      let checked = true;
      value.map((tag) => {
        if (tag.length < 2) {
          callback('每个标签至少两个字符');
          checked = false;
          return;
        }
        if (isChinese(tag) && tag.length > 5) {
          callback('中文标签字数应处于2-5个之间');
          checked = false;
          return;
        }
        if (Number(tag) > 0) {
          callback('标签不能为纯数字组成');
          checked = false;
          return;
        }
      });
      if (checked) {
        callback();
      }
    };
    return {
      editor: null,
      toolbarConfig: {
        excludeKeys: ['uploadVideo', 'fullScreen', 'emotion']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      mode: 'default', // or 'simple'
      commitLoading: false,
      classes: [],
      existTags: [],
      selectedTags: [], // 选中的标签数组
      categoryID: '', // 分类ID
      appPublishTypes: [
        {
          value: 'public',
          label: '免费公开'
        },
        {
          value: 'integral',
          label: '金额销售'
        },
        {
          value: 'private',
          label: '私有'
        },
        {
          value: 'show',
          label: '展览'
        }
      ],
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      editorOption: {},
      rules: {
        name: [
          { required: true, message: '商品名称不能为空', trigger: 'blur' },
          { min: 2, message: '至少两个字符', trigger: 'blur' },
          { max: 200, message: '商品名称建议不超过200个字符', trigger: 'blur' }
        ],
        introduction: [
          { required: false, message: '商品简介不能为空', trigger: 'blur' }
        ],
        description: [
          { required: false, message: '商品介绍不能为空', trigger: 'blur' }
        ],
        installDoc: [
          { required: false, message: '请填写安装文档说明', trigger: 'blur' }
        ],
        screenshots: [
          { required: false, message: '请填写产品截图', trigger: 'blur' }
        ],
        tags: [
          { required: false, message: '请输入标签', trigger: 'blur' }
        ],
        recommended: {
          required: false,
          message: '推荐置顶状态必须指定',
          trigger: 'change'
        }
      },
      allRoleList: []
    };
  },
  created() {
    this.fetchStoreAppClassList();
    this.fetchStoreAppTags();
    this.getOrgStructure();
  },
  computed: {
    myorgs() {
      return this.$store.state.user.userOrgs;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  watch: {
    // 监听 appDetail.tags 变化,同步到 selectedTags
    'appDetail.tags': {
      handler(val) {
        if (typeof val === 'string') {
          // 如果是字符串,按逗号分割成数组
          this.selectedTags = val ? val.split(',').map(tag => tag.trim()) : [];
        } else if (Array.isArray(val)) {
          this.selectedTags = val;
        }
      },
      immediate: true
    },
    // 监听 selectedTags 变化,同步到 appDetail.tags
    selectedTags: {
      handler(val) {
        if (Array.isArray(val)) {
          // 将数组转换为逗号分隔的字符串
          this.appDetail.tags = val.join(',');
        }
      }
    },
    // 监听 appDetail.categoryID 变化,同步到 categoryID
    'appDetail.categoryID': {
      handler(val) {
        this.categoryID = val || '';
      },
      immediate: true
    },
    // 监听 categoryID 变化,同步到 appDetail.categoryID
    categoryID: {
      handler(val) {
        this.appDetail.categoryID = val;
      }
    }
  },
  methods: {
    // 获取所有角色
    getOrgStructure() {
      this.roleLoading = true;
      getOrgStructureApi({
        eid: this.userInfo.eid
      })
        .then((res) => {
          if (res) {
            this.allRoleList = res.children;
          }
        })
        .catch((err) => {});
    },
    uploadImg(file, insertFn) {
      const imgData = new FormData();
      imgData.append('file', file);
      axios({
        url: this.uploadConfig.api,
        method: 'post',
        data: imgData
      }).then((response) => {
        insertFn(response.data.FileURL);
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    fetchStoreAppTags() {
      getStoreAvailableTags({
        marketID: this.marketID,
        size: -1
      })
        .then((res) => {
          if (res && res.tags) {
            const tags = [];
            res.tags.map((item) => {
              tags.push(item.name);
            });
            this.existTags = tags;
          }
        })
        .catch((err) => {
          this.Loading = false;
        });
    },
    fetchStoreAppClassList() {
      this.$store
        .dispatch('GetCategoryList', {
          marketID: this.marketID,
          disableTree: true
        })
        .then((res) => {
          if (res) {
            this.classes = res;
          }
        })
        .catch(() => {});
    },
    fetchUserOrgs() {
      this.$store
        .dispatch('GetUserOrgList')
        .then((res) => {
          if (res) {
            this.myorgs = res;
          }
        })
        .catch(() => {});
    },
    markdownContentUpdate(md, render) {
      this.appData.introduction_html = render;
    },
    markdownImgAdd(pos, $file) {
      // 第一步.将图片上传到服务器.
      var formdata = new FormData();
      formdata.append('file', $file);
      axios({
        url: this.api,
        method: 'post',
        data: formdata,
        headers: this.Token
      }).then((re) => {
        if (re && re.data && re.data.data) {
          this.$refs.md.$img2Url(pos, re.data.data);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.appDetail.logo = res.FileURL;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.warning(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.warning('上传失败!');
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.warning('上传Logo图片只能是JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.warning('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPng) && isLt2M;
    },
    handleRemove() {
      this.$confirm('是否删除logo', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.appDetail.logo = '';
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeSelectApp_type_id(value) {
      this.appData.app_type_id = value;
      this.$forceUpdate();
    },
    changeSelectPublish_type(value) {
      this.appData.publish_type = value;
      this.$forceUpdate();
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.commitLoading = true;
          this.$confirm('是否提交数据', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              const params = {
                marketID: this.marketID,
                productID: this.appDetail.productID,
                name: this.appDetail.name,
                categoryID: this.appDetail.categoryID,
                organizationID: this.appDetail.organizationID,
                tags: this.appDetail.tags,
                recommended: this.appDetail.recommended,
                logo: this.appDetail.logo,
                introduction: this.appDetail.introduction,
                screenshots: this.appDetail.screenshots,
                installDoc: this.appDetail.installDoc,
                description: this.appDetail.description,
                status: this.appDetail.status
              };

              // 清理空字符串字段
              Object.keys(params).forEach(key => {
                if (params[key] === '') {
                  delete params[key];
                }
              });

              this.$store
                .dispatch('UpdateProduct', params)
                .then((res) => {
                  this.$message.success('商品信息更新成功');
                  this.commitLoading = false;
                })
                .catch((err) => {
                  errorHandle(err);
                  this.commitLoading = false;
                });
            })
            .catch(() => {
              this.commitLoading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import 'src/styles/detail-workspace.scss';

.editorStyle {
  ::v-deep .w-e-text-container > .w-e-scroll > div ol li {
    list-style: auto;
  }

  ::v-deep .w-e-text-container > .w-e-scroll > div ul li {
    list-style: disc;
  }

  ::v-deep .w-e-text-placeholder {
    top: 7px;
  }
}

.barStyle {
  ::v-deep .w-e-bar-item {
    padding: 2.5px;
  }

  ::v-deep .w-e-bar-item > button > .title {
    border-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/productManage/components/basicInfo.vue